<template>
    <div>
        <dynamic-search
            :data="tableFilterList(tableHead)"
            @search="dataTableSearch"
            >
            <template v-slot:next>
                <el-button icon="el-icon-plus" v-if="!isAdmin" @click="add()">新增</el-button>
            </template>
        </dynamic-search>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isAdmin: false,
            tableHead: [
                {
                    lable: "单据",
                    prop: "code",
                    align: "center"
                },
                {
                    lable: "客户简称",
                    prop: "shortName",
                    align: "center"
                },
                {
                    lable: "申请人",
                    prop: "proposer",
                    align: "center"
                },
                {
                    lable: "支持的原因",
                    prop: "supportCause",
                    align: "center"
                },
                {
                    lable: "状态",
                    prop: "status",
                    align: "center"
                },
            ]
        }
    },
    methods: {
        add() {

        }
    }
}
</script>

<style>

</style>
